/**
 * Next.js query values are `string | string[] | undefined`. These read the
 * first value as the type the page needs.
 */
type QueryValue = string | string[] | undefined;

export const parseStringQuery = (query: QueryValue): string | undefined => {
	if (typeof query === 'string') return query;
	if (Array.isArray(query)) return query[0];
	return undefined;
};

/** `NaN` when the value is missing or not a whole number. */
export const parseNumberQuery = (query: QueryValue): number => {
	const value = parseStringQuery(query);
	return value === undefined ? NaN : parseInt(value, 10);
};
